/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isDisabled = props => props.disabled || Array.isArray(props.accessibilityStates) && props.accessibilityStates.indexOf('disabled') > -1;
export default isDisabled;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/modules/AccessibilityUtil/isDisabled.js